import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const app = firebase.initializeApp({
  apiKey: "AIzaSyDhGIKtKMnSpqZLiv6jOh_vyUg7MzM_xik",
  authDomain: "flyer-generator-f5314.firebaseapp.com",
  projectId: "flyer-generator-f5314",
  storageBucket: "flyer-generator-f5314.appspot.com",
  messagingSenderId: "305803037946",
  appId: "1:305803037946:web:416b8191b69ba2678bcd43",
});

export const auth = firebase.auth();

export default app;
